<ng-template #itemTemplate let-item>
    <span [pTooltip]="item.description">
        {{ item.identifier }}
        <ng-container *ngIf="item.name"> - {{ item.name }}</ng-container>
    </span>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    <span [pTooltip]="item.description">
        {{ item.identifier }}
        <ng-container *ngIf="item.name"> - {{ item.name }}</ng-container>
    </span>
</ng-template>
